import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'woelm',
} as IModuleProps;
